/*
* Галерея - используется по всему сайту
* изначально была fullscreen
* #1 - переделал на обычную
* */

var fullscreenGalleryFunc = function(root, doc){
    var identify = function () {
            if ('fullscreenEnabled' in doc) return 'fullscreenEnabled';
            if ('mozFullScreenEnabled' in doc) return 'mozFullScreenEnabled';
            if ('webkitFullscreenEnabled' in doc) return 'webkitFullscreenEnabled';
            if ('msFullscreenEnabled' in doc) return 'msFullscreenEnabled';
            return false;
        }(),
        requestName = function () {
            if (doc.documentElement.requestFullscreen) return 'requestFullscreen';
            else if (doc.documentElement.mozRequestFullScreen) return 'mozRequestFullScreen';
            else if (doc.documentElement.webkitRequestFullscreen) return 'webkitRequestFullscreen';
            else if (doc.documentElement.msRequestFullscreen) return 'msRequestFullscreen';
        }(),
        exitName = function () {
            if (doc.exitFullscreen) return 'exitFullscreen';
            else if (doc.mozCancelFullScreen) return 'mozCancelFullScreen';
            else if (doc.webkitCancelFullScreen) return 'webkitCancelFullScreen';
            else if (doc.msExitFullscreen) return 'msExitFullscreen';
        }(),
        eventName = function () {
            if ('onfullscreenchange' in doc) return 'fullscreenchange';
            if ('onmozfullscreenchange' in doc) return 'mozfullscreenchange';
            if ('onwebkitfullscreenchange' in doc) return 'webkitfullscreenchange';
            if ('onmsfullscreenchange' in doc) return 'MSFullscreenChange';
            return false;
        }(),
        elementName = function () {
            if ('fullscreenElement' in doc) return 'fullscreenElement';
            if ('mozFullScreenElement' in doc) return 'mozFullScreenElement';
            if ('webkitFullscreenElement' in doc) return 'webkitFullscreenElement';
            if ('msFullscreenElement' in doc) return 'msFullscreenElement';
            return false;
        }(),
        FullscreenGallery = class {
            constructor(wrapper) {
                this._createElements(wrapper);
                this._addEvents();
            }
            _createElements(wrapper){
                this.wrapper = wrapper;
                this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
                this.itemAll = this.wrapper.querySelectorAll('[data-fullscreenGallery-item]');
                this.curInd = 0;
                this.count = this.itemAll.length;
                this.frame = false;
                this.top = false;
                this.frameImageFrame = false;
                this.frameTitle = false;
            }
            _addEvents(){
                let self = this;

                for(var i= 0,j=this.itemAll.length; i<j; i++){
                    this.itemAll[i].onclick = (function(i){
                        return function(){
                            self._open.call(self, JSON.parse(this.getAttribute('data-fullscreenGallery-item')), i);
                            return false;
                        }
                    })(i);
                }
            }
            _open(data, curInd){
                this.curInd = curInd;
                this._createFrame();
                this._addData(data);
                if(document.body.className.indexOf('js-fullscreen') === -1) document.body.className = document.body.className + ' js-fullscreen';

            }
            _next(e){
                var newInd;

                newInd = this.curInd + 1;
                if (this.count === newInd)  newInd = 0;

                this._move(newInd);
            }

            _prev(e){
                var newInd;

                newInd = this.curInd - 1;
                if (newInd < 0)  newInd = this.count-1;

                this._move(newInd);
            }

            _move(newInd){
                this.curInd = newInd;
                this._addData(JSON.parse(this.itemAll[this.curInd].getAttribute('data-fullscreenGallery-item')));
            }

            _createFrame() {
                var self = this, box, close,
                    changeCallback = function (e) {
                        self._changeCallback.call(self, e, changeCallback)
                    };

                this._changeHeightLocking = function(){self._changeHeight.call(self)};

                box = doc.createElement('DIV');
                box.className = 'fullscreen';
                box.innerHTML = '<svg data-js="close" class="fullscreen_close symbol symbol-x" role="img"><use xlink:href="/static/img/symbols/sprite.svg#x"></use></svg>'+
                    '<div class="fullImage">'+
                    '<div class="fullImage_line">'+
                    '<div data-fullscreenGallery-top class="fullImage_item fullImage_item-top">'+
                    '<div data-fullscreenGallery-imageFrame class="fullImage_imageFrame"></div>'+
                    '<div class="fullImage_btn fullImage_btn-left" data-fullscreenGallery-btn="left">' +
                    '<svg class="fullImage_btnIcon symbol symbol-cornerArrow" role="img"><use xlink:href="/static/img/symbols/sprite.svg#cornerArrow"></use></svg>' +
                    '</div>' +
                    '<div class="fullImage_btn fullImage_btn-right" data-fullscreenGallery-btn="right">' +
                    '<svg class="fullImage_btnIcon symbol symbol-cornerArrow" role="img"><use xlink:href="/static/img/symbols/sprite.svg#cornerArrow"></use></svg>' +
                    '</div>' +
                    '</div>'+
                    '</div>'+
                    '<div class="fullImage_line">'+
                    '<div class="fullImage_item fullImage_item-bottom">'+
                    '<div class="fullImage_content">'+
                    '<div class="fullImage_contentItem">'+
                    '<span data-fullscreenGallery-title class="fullImage_title">&nbsp;</span>'+
                    '</div>'+
                    '<div class="fullImage_contentItem">'+
                    '<!-- <nav class="fullImage_wallpapers menuBtn menuBtn-withTitle">'+
                    '<span class="menuBtn_title">Обои:</span>'+
                    '<div class="menuBtn_content">'+
                    '<a class="menuBtn_item btn btn-default btn-view3" href="#">компьютер</a>'+
                    '<a class="menuBtn_item btn btn-default btn-view3" href="#">аланшет</a>'+
                    '<a class="menuBtn_item btn btn-default btn-view3" href="#">смартфон</a>'+
                    '</div>'+
                    '</nav> -->'+
                    '</div>'+
                    '<div class="fullImage_contentItem align-right">'+
                    '<!--<div class="fullImage_social symbols">'+
                    '<a href="#"><svg class="symbols_item symbol symbol-vk" role="img"><use xlink:href="img/symbols/sprite.svg#vk"></use></svg></a>'+
                    '<a href="#"><svg class="symbols_item symbol symbol-fb" role="img"><use xlink:href="img/symbols/sprite.svg#fb"></use></svg></a>'+
                    '<a href="#"><svg class="symbols_item symbol symbol-tw" role="img"><use xlink:href="img/symbols/sprite.svg#tw"></use></svg></a>'+
                    '<a href="#"><svg class="symbols_item symbol symbol-ok" role="img"><use xlink:href="img/symbols/sprite.svg#ok"></use></svg></a>'+
                    '</div>-->'+
                    '</div>'+
                    '</div>'+
                    '</div>'+
                    '</div>'+
                    '</div>';

                doc.body.appendChild(box);

                var closeBtn = box.querySelector('[data-js="close"]');

                closeBtn.onclick = function () {
                    self._removeFrame.call(self);
                };

                this.frame = box;
                this.top = this.frame.querySelector('[data-fullscreenGallery-top]');
                this.frameImageFrame = this.frame.querySelector('[data-fullscreenGallery-imageFrame]');
                this.frameTitle = this.frame.querySelector('[data-fullscreenGallery-title]');
                this.btnLeft = this.frame.querySelector('[data-fullscreenGallery-btn="left"]');
                this.btnRight = this.frame.querySelector('[data-fullscreenGallery-btn="right"]');

                if(this.count !== 1){
                    this.btnRight.addEventListener('click', () => {this._next()});
                    this.btnLeft.addEventListener('click', () => {this._prev()});
                } else {
                    this.top.removeChild(this.btnRight);
                    this.top.removeChild(this.btnLeft);
                }

                window.addEventListener('resize', this._changeHeightLocking, false);
                this._changeHeightLocking();
            }

            _changeHeight(){
                var self = this,
                    change = function(){
                        var box = self.top.getBoundingClientRect(),
                            h = box.bottom - box.top;

                        if(h > 0) self.frameImageFrame.style.height = h + 'px';
                        else {
                            requestAnimationFrame(change);
                        }
                    };
                change();
            }

            _addData(data){
                var title = data.title ? data.title : this.param.title;

                this.frameImageFrame.innerHTML = '<img data-fullscreenGallery-image class="fullImage_image" src="'+ data.image +'" alt="" title="'+ title +'" />';
                this.frameTitle.innerHTML = title;
            }
            _removeFrame(){
                doc.body.removeChild(this.frame);
                if(document.body.className.indexOf('js-fullscreen') !== -1)  document.body.className = document.body.className.replace(' js-fullscreen', '');
                window.removeEventListener('resize', this._changeHeightLocking);

                delete this.frame;
                delete this.frameTitle;
            }
        },
        fullscreenGallery = function (wrapper) {
            if (!window.requestAnimationFrame) return false;
            return new FullscreenGallery(wrapper);
        };

    return fullscreenGallery;
};

export {fullscreenGalleryFunc};
































